import React, { Component } from 'react'

export default class Test extends Component {
  render() {
    return (
      <div>
        <h1>测试</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/containers/master/Test.jsx